/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageDisasterPreventionOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageDisasterPreventionOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageDisasterPreventionOverviewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageDisasterPreventionOverviewPage~SignageDisasterPreventionOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'notSetUp', 'area':'notSetUpArea'},
                {'item':'onSetUp', 'area':'onSetUpArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setDisasterPreventionOviewviewInfo();
            },

            /**
             * 体制概況情報を設定します
             */
            setDisasterPreventionOviewviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 体制概況情報を設定
                    var disasterPrevInfo = item.items.filter(function(element) {
                        return element.municipalityName === null;
                    });
                    this.setDisasterPrevInfo(this, disasterPrevInfo);
                    var disasterPrevList = item.items.filter(function(element) {
                        return element.municipalityName !== null;
                    });
                    this.setDisasterPrevList(this, disasterPrevList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var disasterPrevInfo = {};
                        this.setDisasterPrevInfo(this, disasterPrevInfo);
                        var disasterPrevList = [];
                        this.setDisasterPrevList(this, disasterPrevList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 県の体制概況情報を設定します
             */
            setDisasterPrevInfo: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });


                // 更新状態を設定
                this.setDisasterPrevInfoUpdate(self, item);
            },

            /**
             * 県の体制概況情報の更新状態を設定します
             */
            setDisasterPrevInfoUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var disasterPrevInfo = prevItem.items[0];
                if (disasterPrevInfo) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (disasterPrevInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 体制概況情報一覧を設定します
             */
            setDisasterPrevList: function(self, data) {
                // 表示をクリア
                var disasterPreventionOverviewTBody = dojo.byId('disasterPreventionOverviewTBody');
                domConstruct.empty(disasterPreventionOverviewTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);    
                }
                var prevItem = prevItemStore[this._screenId];
                var disasterPrevList = [];
                if (prevItem) {
                    disasterPrevList = prevItem.items.filter(function(element) {
                        return element.municipalityName !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 体制概況(リスト)の前回値
                    var disasterprevItem = null;
                    if (disasterPrevList && disasterPrevList.length > 0) {
                        disasterprevItem = disasterPrevList.filter((element) =>
                            element.municipalityName === item.municipalityName
                        )[0];
                        // 新規のデータが追加された場合は前回値を空文字として設定
                        if (disasterprevItem === undefined) {
                            disasterprevItem = {
                                "municipalityName": "", 
                                "statusName": "", 
                                "setFlg": "",
                                "setTimestamp": "",
                                "abolishedTimestamp": ""
                            };
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 市町村
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 体制名称
                    className = disasterprevItem && (disasterprevItem.statusName !== item.statusName) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.statusName, class: className}), tr);

                    // 本部設置状況
                    // 本部設置/解散日時
                    var setUpStatus = '';
                    var setStatus = '';
                    var addBgStyle = '';
                    var addStyle = '';
                    var timeStamp = '-';
                    switch (item.setFlg) {
                        case '0':
                            setUpStatus = '-';
                            break;
                        case '1':
                            setUpStatus = '設置済み';
                            setStatus = '<br> 設置';
                            addBgStyle = '#EC0000';
                            addStyle = 'white';
                            timeStamp = item.setTimestamp + setStatus;
                            break;
                        case '2':
                            setUpStatus = '解散';
                            setStatus = '<br> 解散';
                            addBgStyle = '#CCCCCC';
                            addStyle = 'black';
                            timeStamp = item.abolishedTimestamp + setStatus;
                            break;
                    }
                    className = disasterprevItem && (disasterprevItem.setFlg !== item.setFlg) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + setUpStatus, class: className}), tr);

                    className = disasterprevItem && (disasterprevItem.setTimestamp !== item.setTimestamp) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + timeStamp + '</span>', class: className, 
                        style: 'background-color: ' + addBgStyle + '; color: ' + addStyle + ';'}), tr);


                    domConstruct.place(tr, disasterPreventionOverviewTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setDisasterPrevList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
